import React from "react";
import {
  FormControl,
  Text,
  RadioGroup,
  Radio,
  Tooltip,
  Flex,
  Image,
} from "@chakra-ui/react";
import { info } from "../../assets/new-images/icons";

export const CustomRadioGroup = ({
  label,
  fieldName,
  register,
  error = null,
  hasTooltip = false,
  tooltipLabel = "",
  isDisabled = false,
  defaultValue = "Não",
  onRadioChange,
  ...rest
}) => {
  return (
    <FormControl
      isInvalid={!!error}
      isDisabled={isDisabled}
      width="fit-content"
      {...rest}
    >
      <Flex gap="5px" mb="4px">
        <Text
          as="span"
          fontSize="sm"
          color="#818A8F"
          lineHeight="17.36px"
          whiteSpace="nowrap"
          display="block"
        >
          {label}
        </Text>
        {hasTooltip && (
          <Tooltip
            hasArrow
            label={tooltipLabel}
            aria-label={tooltipLabel}
            bg="#CCCFD1"
            color="black.100"
            textAlign="center"
            minW="417px"
            p="8px 16px"
            borderRadius="4px"
          >
            <span>
              <Image src={info} atl="" w="16.67px" />
            </span>
          </Tooltip>
        )}
      </Flex>
      <RadioGroup
        defaultValue={defaultValue}
        className="template-radio"
        onChange={onRadioChange}
      >
        <Flex gap="12px">
          <Radio id={`${fieldName}_no`} {...register(fieldName)} value="Não">
            Não
          </Radio>
          <Radio id={`${fieldName}_yes`} {...register(fieldName)} value="Sim">
            Sim
          </Radio>
        </Flex>
      </RadioGroup>
    </FormControl>
  );
};
